import { Dispatch } from 'redux';

import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { ISignSubjectInfo, ISignSubjectInfoCheckResult } from 'APIPackage/KnmModule/interfaces/ISignSubjectInfo';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

type CheckSignApiFn = (subjectInfo: ISignSubjectInfo, id?: string | number) => Promise<ISignSubjectInfoCheckResult>;

export const createCheckSignCertificateHandler = (
  dispatch: Dispatch<RootActions>,
  checkApiFn: CheckSignApiFn,
  id: string | number | undefined,
  isEnableKnoValidationSigning: boolean,
) => {
  return (subjectInfo: ISignSubjectInfo, abort: () => void, proceed: () => void) => {
    dispatch(coreSetLoading(true));

    checkApiFn(subjectInfo, id)
      .then((checkResult: ISignSubjectInfoCheckResult) => {
        let hasError = false;

        dispatch(coreSetLoading(false));

        if (checkResult?.orgNameError) {
          const noticeType = isEnableKnoValidationSigning ? NoticeTypesEnum.ERROR : NoticeTypesEnum.WARNING;

          dispatch(
            addNoticeAction({
              renderContent: checkResult.orgNameError,
              noticeType,
              messageType: MessageTypesEnum.VALIDATION_PM_SIGN,
            }),
          );

          if (isEnableKnoValidationSigning) {
            hasError = true;
          }
        }

        if (checkResult?.fieldsCheckResult?.length) {
          checkResult?.fieldsCheckResult.forEach(checkErrorMessage => {
            dispatch(
              addNoticeAction({
                renderContent: checkErrorMessage,
                noticeType: NoticeTypesEnum.ERROR,
                messageType: MessageTypesEnum.VALIDATION_PM_SIGN,
              }),
            );
            hasError = true;
          });
        }

        if (hasError) {
          abort();
        } else {
          proceed();
        }
      })
      .catch(() => {
        dispatch(coreSetLoading(false));
        dispatch(
          addNoticeAction({
            renderContent:
              'Не удалось произвести проверку соответствия данных паспорта и данных сертификата пользователя. Необходимо обратиться в службу технической поддержки.',
            noticeType: NoticeTypesEnum.ERROR,
            messageType: MessageTypesEnum.PASSPORT_SIGN,
          }),
        );

        abort();
      });
  };
};
